import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import './styles/evaluations.scss';
import './styles/organizations.scss';
import './styles/categories.scss';
import LandingPage from './LandingPage';

const Administrators = lazy(() => import('./Administrators/index'));
const Assessments = lazy(() => import('./Assessments/index'));
const Awards = lazy(() => import('./Awards/index'));
const Benchmarks = lazy(() => import('./Benchmarks/index'));
const Content = lazy(() => import('./Content/index'));
const ContentAwardRules = lazy(() => import('./ContentAwardRules/index'));
const BouncedEmails = lazy(() => import('./BouncedEmails/index'));
const ContentConfigs = lazy(() => import('./ContentConfigs/index'));
const ContentPackages = lazy(() => import('./ContentPackages/index'));
const Forms = lazy(() => import('./Forms/index'));
const FoundryUsers = lazy(() => import('./FoundryUsers/index'));
const Layouts = lazy(() => import('./Layouts/index'));
const Organizations = lazy(() => import('./Organizations/index'));
const Polls = lazy(() => import('./Polls/index'));
const ReportConfigs = lazy(() => import('./ReportConfigs/index'));
const Resources = lazy(() => import('./Resources/index'));
const ScormPackages = lazy(() => import('./ScormContentPackages/index'));
const SendMailServers = lazy(() => import('./SendMailServers/index'));
const SuppressionLists = lazy(() => import('./SuppressionLists/index'));
const Surveys = lazy(() => import('./Surveys/index'));
const SystemMessaging = lazy(() => import('./SystemMessaging/index'));
const Templates = lazy(() => import('./Templates/index'));

function AdminApp() {
  return (
    <Routes>
      <Route path="administrators/*" element={<Administrators />} />
      <Route path="assessments/*" element={<Assessments />} />
      <Route path="awards/*" element={<Awards />} />
      <Route path="benchmarks/*" element={<Benchmarks />} />
      <Route path="contents/*" element={<Content />} />
      <Route path="content_award_rules/*" element={<ContentAwardRules />} />
      <Route path="bounced_emails/*" element={<BouncedEmails />} />
      <Route path="business_resources/*" element={<Resources />} />
      <Route path="content_configs/*" element={<ContentConfigs />} />
      <Route path="content_packages/*" element={<ContentPackages />} />
      <Route path="forms/*" element={<Forms />} />
      <Route path="foundry_users/*" element={<FoundryUsers />} />
      <Route path="layouts/*" element={<Layouts />} />
      <Route path="organizations/*" element={<Organizations />} />
      <Route path="polls/*" element={<Polls />} />
      <Route path="report_configs/*" element={<ReportConfigs />} />
      <Route path="scorm_packages/*" element={<ScormPackages isAdmin={true} />} />
      <Route path="send_mail_servers/*" element={<SendMailServers />} />
      <Route path="suppression_lists/*" element={<SuppressionLists />} />
      <Route path="surveys/*" element={<Surveys />} />
      <Route path="system_messages/*" element={<SystemMessaging />} />
      <Route path="templates/*" element={<Templates />} />
      <Route path="*" element={<LandingPage />} />
    </Routes>
  );
}

export default AdminApp;
